import { Link } from "react-router-dom";
import Nav from "@/components/Nav";
import { XCircle } from "lucide-react";

const PaymentCancel = () => (
  <div data-testid="payment-cancel-page" className="bg-background text-foreground min-h-screen">
    <Nav />
    <main className="max-w-[760px] mx-auto px-6 pt-40 pb-24 text-center">
      <XCircle className="w-10 h-10 mx-auto text-muted-foreground" />
      <h1 className="font-display font-black tracking-tight text-4xl mt-8">Checkout cancelled.</h1>
      <p className="text-sm text-muted-foreground mt-4">
        Nothing was charged. The pilot package will be here when you&apos;re ready.
      </p>
      <Link
        data-testid="cancel-home-link"
        to="/"
        className="inline-block mt-8 border border-foreground font-mono text-xs tracking-[0.2em] uppercase px-8 py-4 hover:bg-foreground hover:text-background transition-colors duration-200"
      >
        Back Home
      </Link>
    </main>
  </div>
);

export default PaymentCancel;
